var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getDiscoveredEquipment, getDiscoveryService, VisionarySolutionsBase, } from './util/VisionarySolutionsBase';
export class VisionarySolutions5 extends VisionarySolutionsBase {
    constructor() {
        super(...arguments);
        this.discoveryService = getDiscoveryService(VisionarySolutions5.key);
    }
}
VisionarySolutions5.emulatorKey = '-NPrrY6eB7EkwX7N30Sj';
VisionarySolutions5.key = '-ORMKoN7qD6Xb3JB1ZhF';
VisionarySolutions5.discoverEquipment = () => __awaiter(void 0, void 0, void 0, function* () {
    return getDiscoveredEquipment(VisionarySolutions5.key);
});
